import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI } from "../utils/fetchData";
import Adminnavbar from "./adminnavbar";
import Footer from "./footer";
import LoginRequest from "./loginRequest";
import Sidenavbar from "./sidenav";

// Constants for styles
const CONTAINER_STYLE = { backgroundColor: "#ffffff", padding: "30px" };
const DASHBOARD_ROW_STYLE = {
	paddingTop: "20px",
	paddingBottom: "20px",
	backgroundColor: "#A7D588",
};

const DASHBOARD_CARDS = [
	{ key: "totalvideos", label: "Total Videos", bgColor: "#24A2B3" },
	{ key: "totaldocuments", label: "Total Documents", bgColor: "#E96CB4" },
	{ key: "totalbooks", label: "Total Books", bgColor: "#7F2DA2" },
];

const Digitallibrarymanagement = () => {
	const { auth } = useSelector((state) => state);
	const [dlDetails, setDlDetails] = useState({});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {
		const fetchDlDetails = async () => {
			if (!auth.token) return;

			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				setLoading(true);
				setError(null);

				const res = await getDataAPI(`getdigitallibrarycount`, auth.token);
				setDlDetails(res.data.dldetails || {});
			} catch (err) {
				console.error("Error fetching digital library details:", err);
				setError("Failed to load digital library statistics");
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch digital library details" },
				});
			} finally {
				setLoading(false);
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { loading: false },
				});
			}
		};

		fetchDlDetails();
	}, [auth.token, dispatch]);

	// Memoize dashboard cards to prevent unnecessary re-renders
	const dashboardCards = useMemo(() => {
		return DASHBOARD_CARDS.map((card) => (
			<div
				key={card.key}
				className="col text-format"
				style={{ backgroundColor: card.bgColor }}>
				<div className="text1">{dlDetails[card.key] || 0}</div>
				<div className="text1">{card.label}</div>
			</div>
		));
	}, [dlDetails]);

	if (!auth.user) {
		return <LoginRequest />;
	}

	return (
		<>
			<Adminnavbar />
			<div style={CONTAINER_STYLE}>
				<div className="dashboard-text">Super Admin Dashboard</div>
				<div id="admin">
					<div>
						<div className="row format">
							<Sidenavbar />
							<div className="col-8">
								{loading ? (
									<div className="text-center p-4">
										Loading digital library statistics...
									</div>
								) : error ? (
									<div className="text-center p-4 text-danger">{error}</div>
								) : (
									<div className="row format" style={DASHBOARD_ROW_STYLE}>
										{dashboardCards}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default Digitallibrarymanagement;
